/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box } from "@nordcloud/gnui";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { ReportsTable } from "./components/Reports/ReportsTable";

export function Reports() {
  const breadcrumbsLabels = [
    { label: "Dashboard", uri: "/" },
    { label: "Reports", uri: ROUTES.resources.reports },
  ];

  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Reports"
            customBreadcrumbs={breadcrumbsLabels}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <ReportsTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
